import EdoProfile from 'components/global/Profile';

export default EdoProfile;
